import { muiPalette } from './muiPalette';
import { muiTypography } from './muiTypography';

export const chipOverride = {
  MuiChip: {
    styleOverrides: {
      root: {
        height: 28,
        borderRadius: '4px',
        backgroundColor: muiPalette.palette.grey[200],
        '&.Mui-focusVisible': {
          backgroundColor: muiPalette.palette.grey[200]
        },
        fontSize: muiTypography.typography.caption.fontSize,
        '&.Mui-disabled': {
          background: muiPalette.palette.action.disabledBackground,
          opacity: 1,
          color: muiPalette.palette.action.disabled,
          '& .MuiChip-icon, & .MuiChip-deleteIcon': {
            color: muiPalette.palette.action.disabled
          }
        }
      },
      //Used in Chip-Selection component
      outlinedPrimary: {
        border: 'none',
        '.MuiChip-clickable&:hover': {
          backgroundColor: muiPalette.palette.action.hover
        },
        '&:not(.Mui-disabled)&:focus': {
          color: muiPalette.palette.primary.dark
        },
        '& .MuiChip-deleteIcon': {
          color: `${muiPalette.palette.grey[500]}`,
          '&:hover': {
            color: `${muiPalette.palette.grey[700]}`
          }
        }
      },
      outlined: {
        border: 'none'
      },
      deleteIcon: {
        width: 16,
        height: 16,
        color: `${muiPalette.palette.grey[500]}`,
        '&:hover': {
          color: `${muiPalette.palette.grey[700]}`
        }
      },
      deletable: {
        '&:focus': {
          boxShadow: `0px 0px 0px 1px ${muiPalette.palette.primary.main} inset`
        }
      },
      label: {
        paddingLeft: 8,
        paddingRight: 8
      },
      clickable: {
        '&:focus': {
          boxShadow: `0px 0px 0px 1px ${muiPalette.palette.primary.main} inset`
        }
      }
    }
  }
};
